import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import Clickable from '@prisjakt/ui-clickable';
import { Truncated } from '../../../../components/truncated';
import {
  HorizontalScrollContainer,
  Inner as HorizontalScrollInner,
} from '../../../../components/horizontal-scroll/styles';

const ITEM_WIDTH = 120;
const MEDIA_SIZE = 60;

export const Wrapper = styled.section`
  margin-bottom: ${layout.measurements.spacing050};

  ${HorizontalScrollContainer} {
    margin-left: -${layout.measurements.spacing100};
    margin-right: -${layout.measurements.spacing100};

    ${HorizontalScrollInner} {
      padding: 0 ${layout.measurements.spacing100};
    }
  }
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  max-width: 100%;
`;

export const List = styled.ul.attrs({
  'data-test': 'NavigationList',
})<{
  $showAll: boolean;
  $itemLimit: number;
}>`
  display: inline-flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0 -5px;
  flex-basis: ${p => {
    const width = p.$showAll ? Math.max(p.$itemLimit, 6) : p.$itemLimit;
    return width * ITEM_WIDTH;
  }}px;
  ${p =>
    !p.$showAll &&
    css`
      height: 160px;
      overflow: hidden;
    `}
`;

export type ListItemProps = {
  selected?: boolean;
};

const listItemStyles = css<ListItemProps>`
  width: ${ITEM_WIDTH}px;
  min-width: ${ITEM_WIDTH}px;
  height: 140px;
  min-height: 140px;
  display: block;
`;

export const ListItem = styled.li<ListItemProps>`
  ${listItemStyles}
  margin-bottom: ${layout.measurements.spacing125};
`;

export const ListItemDiv = styled.div<ListItemProps>`
  ${listItemStyles}
`;

export const ListItemLink = styled(Clickable)`
  width: 100%;
  height: 100%;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  position: relative;
`;

export const ListItemText = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
`;

const numberWithDefault = (value: number | undefined, defaultValue: number) =>
  value !== undefined ? value : defaultValue;

type LimitedTextFieldProps = {
  lines?: number;
  lineHeight?: number;
};

export const LimitedTextField = styled(Truncated).attrs<LimitedTextFieldProps>(
  ({ lines }) => ({ maxLines: numberWithDefault(lines, 2) })
)<LimitedTextFieldProps>`
  line-height: ${({ lineHeight }) => numberWithDefault(lineHeight, 1.2)}rem;
  max-height: ${({ lines, lineHeight }) =>
    numberWithDefault(lines, 2) * numberWithDefault(lineHeight, 1.2)}rem;
  word-break: break-word;
  white-space: normal;
`;

export const ListItemImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: ${MEDIA_SIZE}px;
  height: ${MEDIA_SIZE}px;
`;

export const ListAction = styled.div`
  ${listItemStyles}
  display: block;
  margin: 0px auto ${layout.measurements.spacing125} auto;
`;

export const ListActionButton = styled.div`
  width: ${MEDIA_SIZE}px;
  height: ${MEDIA_SIZE}px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
